"use client";

interface QuizProgressBarProps {
  progress: number;
}

export function QuizProgressBar({ progress }: QuizProgressBarProps) {
  return (
    <div className="w-full h-[4px] rounded-[12px] bg-[#F3F2F1]">
      <div
        className="h-full rounded-[12px] bg-black transition-all duration-300"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
